var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styleObj)},[_c('Table',{attrs:{"height":_vm.height,"columns":_vm.columns,"data":_vm.cityData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }